var __default__ = {root:'m_b37d9ac7',notification:'m_5ed0edd0'};
export default __default__;